export default class Utils {
  
  static testShowConsoleLogParam (log) {
    if (log.object && log.variableToLog) {
      console.log(log.object, log.variableToLog)
    } else {
      console.error("Missing parameter. Param should be a array of Object with keys 'object' and 'variableToLog'", log)
    }
  }
  
  /**
   * 
   * @param {Array} logs
   * @returns {void}
   */
  static showConsoleLog (logs) {
    if (process.env.NODE_ENV === 'development') {
      if (Array.isArray(logs)) {
        for (const log of logs) {
          this.testShowConsoleLogParam(log)
        }
      } else {
        this.testShowConsoleLogParam(logs)
      }
    }
  }

  /**
   * 
   * @param {Array} arrayData 
   * @param {String} sortByProperty
   * @param {String} sortType
   * @returns {Array}
   */
  static dataSorting (arrayData, sortByProperty = 'label', sortType = 'asc') {
    if (Array.isArray(arrayData) && arrayData[0][sortByProperty]) {
      if (sortType === 'asc') {
        arrayData.sort((a, b) => {
          const labelA = a[sortByProperty]
          const labelB = b[sortByProperty]
          if (labelA < labelB) {
            return -1
          }
          if (labelA > labelB) {
            return 1
          }
              
          return 0
        })
      } else {
        arrayData.sort((a, b) => {
          const labelA = a[sortByProperty]
          const labelB = b[sortByProperty]
          if (labelA < labelB) {
            return 1
          }
          if (labelA > labelB) {
            return -1
          }
              
          return 0
        })
      }
    }

    return arrayData
  }

}